import { Geolocation } from '~/models/common/types'

export const CENTER_OF_GREECE: Geolocation = Object.freeze({
  lat: 37.98381,
  lon: 23.727539
})

export const GREECE_BOUNDS: google.maps.LatLngBoundsLiteral = Object.freeze({
  north: 42.73,
  south: 31.78,
  west: 15.29,
  east: 29.28
})

export const CYPRUS_BOUNDS: google.maps.LatLngBoundsLiteral = Object.freeze({
  north: GREECE_BOUNDS.north,
  south: GREECE_BOUNDS.south,
  west: GREECE_BOUNDS.west,
  east: 40.0
})

// NOTE: be careful when setting bounds
// the country points closest to the country's actual bounds must be able to be centered in the map when zoom is at
// its minimum otherwise there are going to be zooming problems when going from total zoom out to zoom 15
// that's why the following bounds are way beyond GR, CY and BG.
export const GR_CY_BG_BOUNDS: google.maps.LatLngBoundsLiteral = Object.freeze({
  north: 52.4,
  south: 24.8,
  west: -4.29,
  east: 59.0
})
